import { defineNuxtPlugin } from 'nuxt/app';
import ConfirmationService from 'primevue/confirmationservice';
import DialogService from 'primevue/dialogservice';

export default defineNuxtPlugin(({ vueApp }) => {
	vueApp.use(ConfirmationService);
	vueApp.use(DialogService);
});
